import { createSelector } from 'reselect';

const getConfigState = (state) => state.getIn(['config']);

export const langSelector = createSelector([getConfigState], (config) =>
  config.get('lang')
);
